import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import Button from '../Button/Button';

import './Lead.pcss';

// typograf-enable
const Lead = props => {
  const { isHomePage, goToFirstStep } = props;

  return (
    <div className={cn('Lead', { 'Lead--start': isHomePage })}>
      <div className="Lead__wrapper">
        <h1 className="Lead__title">
          Подача апелляции о&nbsp;несогласии с&nbsp;выставленными баллами
          государственной итоговой аттестации (ЕГЭ,&nbsp;ОГЭ,&nbsp;ГВЭ)
        </h1>
        <div className="Lead__content">
          {isHomePage ? (
            <span>
              Данная услуга позволяет подать апелляцию на результаты ГИА.
              Апелляция может быть подана участником по достижении им 14 лет или
              родителем (законным представителем) участника при наличии
              подтвержденного факта родства в личном кабинете заявителя.
            </span>
          ) : (
            <>
              <p className="Lead__paragraph">
                Заявление на рассмотрение апелляции о несогласии с выставленными
                баллами может подавать сам участник ГИА по достижении им 14 лет,
                либо законный представитель при наличии подтвержденного
                законного представительства участника ГИА в личном кабинете.
              </p>
              <p className="Lead__paragraph">Как это сделать:</p>
              <ul className="List">
                <li>
                  в личном кабинете зайти в{' '}
                  <a
                    href="https://my.mos.ru/my/#/settings/family"
                    rel="noopener noreferrer"
                    target="_blank"
                    className="Link"
                  >
                    раздел «Семья и дети»
                  </a>
                </li>
                <li>внести информацию о ребёнке.</li>
              </ul>
              <p className="Lead__paragraph">
                Если участник ГИА не достиг 14 лет и в случае отсутствия у
                законного представителя подтвержденного законного
                представительства участника ГИА в личном кабинете, то любой из
                них может подать заявление на бумажном носителе в общественной
                приёмной регионального центра обработки информации города Москвы
                по адресу: г. Москва, Семёновская площадь, дом 4. Законному
                представителю при себе необходимо иметь документ, удостоверяющий
                личность, и документ, подтверждающий законное представительство.
                Участнику ГИА потребуется документ, удостоверяющий личность.
              </p>
            </>
          )}
        </div>
        {isHomePage && (
          <div className="Lead__action">
            <Button
              className="Lead__action-button"
              primary
              size="big"
              onClick={() => goToFirstStep(true)}
            >
              Подать апелляцию
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

Lead.defaultProps = {
  isHomePage: false,
  goToFirstStep: () => {}
};

Lead.propTypes = {
  isHomePage: PropTypes.bool,
  goToFirstStep: PropTypes.func
};

export default Lead;
